/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FieldVisibility
 */
export interface FieldVisibility {
    /**
     * 
     * @type {boolean}
     * @memberof FieldVisibility
     */
    mood: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FieldVisibility
     */
    tags: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FieldVisibility
     */
    genre: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FieldVisibility
     */
    share: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FieldVisibility
     */
    playCount: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FieldVisibility
     */
    remixes: boolean;
}

/**
 * Check if a given object implements the FieldVisibility interface.
 */
export function instanceOfFieldVisibility(value: object): value is FieldVisibility {
    let isInstance = true;
    isInstance = isInstance && "mood" in value && value["mood"] !== undefined;
    isInstance = isInstance && "tags" in value && value["tags"] !== undefined;
    isInstance = isInstance && "genre" in value && value["genre"] !== undefined;
    isInstance = isInstance && "share" in value && value["share"] !== undefined;
    isInstance = isInstance && "playCount" in value && value["playCount"] !== undefined;
    isInstance = isInstance && "remixes" in value && value["remixes"] !== undefined;

    return isInstance;
}

export function FieldVisibilityFromJSON(json: any): FieldVisibility {
    return FieldVisibilityFromJSONTyped(json, false);
}

export function FieldVisibilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): FieldVisibility {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mood': json['mood'],
        'tags': json['tags'],
        'genre': json['genre'],
        'share': json['share'],
        'playCount': json['play_count'],
        'remixes': json['remixes'],
    };
}

export function FieldVisibilityToJSON(value?: FieldVisibility | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'mood': value.mood,
        'tags': value.tags,
        'genre': value.genre,
        'share': value.share,
        'play_count': value.playCount,
        'remixes': value.remixes,
    };
}

